import classNames from 'classnames';
import * as style from './PanelTitle.module.less';
import { Center } from '@assets/component/Center/Center';

interface PanelTitleProps {
    children?: React.ReactNode;
    title: string;
    className?: string;
    containerClassName?: string;
}

export const PanelTitle = (props: PanelTitleProps) => {
    const container = classNames(props.containerClassName);
    const cls = classNames(style.panelRowTitle, props.className);
    return (
        <Center className={container}>
            {props.children ? props.children : ''}
            <div className={cls}>{props.title}</div>
        </Center>
    );
};
